<script>
import api from "@/api";
import GameTable from "@/components/GameTable";

export default {
  components: {
    GameTable,
  },

  data: function() {
    return {
      schedule: null,
    };
  },
  mounted() {
    const currentLocale = JSON.parse(localStorage.getItem("locale")) || 'en';
    window.analytics.page();
    this.trackEvent("Reset State", {});
    localStorage.clear();
    localStorage.removeItem("user");
    localStorage.removeItem("currentLeague");
    localStorage.removeItem("currentSeason");
    this.$store.dispatch("signOut").then(() => {      
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      }
      localStorage.clear();
      this.goRouter(`/${currentLocale}/sign-in`);
      this.makeToast("success", "Reset");
    });
  },
};
</script>

<template>
  <div v-if="schedule"></div>
</template>

<style></style>
